import { Group, Paper, Stack, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

import type { ClinicalSummaryDetailsData } from '@/hooks/usePatientClinicalSummaryDetails'

type DetailsMeta = ClinicalSummaryDetailsData['meta']

// Single incomplete-data notice shown above both the Details and Overview tabs. Driven SOLELY by
// the model's overall-completeness flag (`meta.incomplete`); the individual signals behind it
// (truncation, unparsed documents, undisplayable lab rows) are intentionally not surfaced here.
// Wording is deliberately non-technical, per clinician feedback on PD-1095. Renders nothing when
// the data is complete (or the flag is absent on an older stored overview), so callers can mount
// it unconditionally.
export const ClinicalSummaryLimitations = ({ meta }: { meta: DetailsMeta }) => {
  if (!meta.incomplete) return null

  return (
    <Paper
      p="sm"
      withBorder
      className="mb-4 bg-red-50"
      style={{ borderColor: 'var(--mantine-color-red-3)', borderWidth: 1 }}
    >
      <Group gap="xs" align="flex-start" wrap="nowrap">
        <IconAlertTriangle size={18} className="mt-0.5 shrink-0 text-red-600" />
        <Stack gap={2}>
          <Text size="sm" fw={600} className="text-red-800">
            Important: Chart Summary May Be Incomplete
          </Text>
          <Text size="sm" className="text-red-800">
            Some information from labs, vital signs, PDFs, scanned documents, or outside records may
            not appear here. Please verify the original chart and documents before making clinical
            decisions.
          </Text>
        </Stack>
      </Group>
    </Paper>
  )
}
